// utils/downloadExcel.ts
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const downloadExcel = (data: any[], filename: string, reportType: "detail" | "summary") => {
  if (!data || data.length === 0) {
    alert("No data to download.");
    return;
  }

  let formattedData :any= [];

  if (reportType === "detail") {
    formattedData = data.map((entry) => ({
      "Date Time": entry.dateTime,
      "User": entry.user,
      "Type": entry.type,
      "Narration": entry.narration,
      "Opening Balance": entry.openingBalance,
      "Transaction Value": entry.transactionValue,
      "Closing Balance": entry.closingBalance,
    }));
  } else if (reportType === "summary") {
    formattedData = data.map((entry) => ({
      "Date": entry.date,
      "Opening Balance": entry.openingBalance,
      "Total Transaction Value": entry.transaction,
      "Closing Balance": entry.closingCredits,
    }));
  }

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, reportType.toUpperCase());

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(blob, `${filename}.xlsx`);
};
